module.exports = __webpack_public_path__ + "static/img/two.b8c5597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/10/two.png
// module id = k4Xj
// module chunks = 1